module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon3.be50c35e.svg";